/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import has from 'lodash/has';
import { Action, ActionCreators } from './actions';
import Hub from '../../shared/entities/hub';

export interface State {
  beamToHubMap: { [beamId: string]: Hub[] };
  hubsMap: { [hubId: string]: Hub };
  isRequestingHubs: boolean;
  isHubsRequestFinished: boolean;
  requestHubsError?: string;
}

export const initialHubsState: State = {
  beamToHubMap: {},
  hubsMap: {},
  isRequestingHubs: false,
  isHubsRequestFinished: false,
  requestHubsError: undefined,
};

export default function reducer(state: State = initialHubsState, action: Action): State {
  let partialState: Partial<State> | undefined;

  switch (action.type) {
    case ActionCreators.RequestHubs.type:
      partialState = {
        beamToHubMap: {},
        hubsMap: {},
        isRequestingHubs: true,
        isHubsRequestFinished: false,
        requestHubsError: undefined,
      };
      break;

    case ActionCreators.ReceivedHubsSuccess.type: {
      const beamToHubMap = {};
      const tempHubsMap = {};

      if (action.payload.response) {
        action.payload.response.forEach((hub: Hub) => {
          tempHubsMap[hub.id] = hub;
          if (hub && hub.beams) {
            hub.beams
              .filter((beamId: string) => beamId)
              .forEach((beamId: string) => {
                // if the beam id is already in the dictionary, push to the array of hubs for that beam id
                if (has(beamToHubMap, beamId)) {
                  beamToHubMap[beamId].push(hub);
                } else {
                  // create the dictionary entry with the array of one hub for that beam id
                  beamToHubMap[beamId] = [hub];
                }
              });
          }
        });
      }

      partialState = {
        beamToHubMap,
        isRequestingHubs: false,
        isHubsRequestFinished: true,
        requestHubsError: undefined,
        hubsMap: tempHubsMap,
      };
      break;
    }

    case ActionCreators.ReceivedHubsError.type:
      partialState = {
        isRequestingHubs: false,
        isHubsRequestFinished: true,
        requestHubsError: action.payload.message,
      };
      break;

    default:
      return state;
  }
  return { ...state, ...partialState };
}
